import { render } from "./MarkersPage.vue?vue&type=template&id=10952e18"
import script from "./MarkersPage.vue?vue&type=script&lang=js"
export * from "./MarkersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__